<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div class="file-spec-panel" v-html="html" />
</template>

<script setup>
defineProps({
  html: {
    type: String,
    default: "",
  },
});
</script>

<style scoped lang="scss">
.file-spec-panel {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 40vh;

  :deep(sp-info-message) {
    display: block;
    background-color: #b3d4fc;
    border-radius: var(--sp-ref-border-radius-xs);
    padding: var(--sp-spacing-4);
    margin: 0;
    font-size: var(--sp-sys-typescale-small-font-size, 0.875rem);
    font-weight: var(--sp-ref-font-weight-semi-bold);
    line-height: 1.25;
    color: var(--sp-base-font-color, #333);
  }

  :deep(sp-info-message) h2 {
    font-size: 1.25rem;
    margin: 0 0 var(--sp-ref-spacing-4);
  }

  :deep(sp-info-message) h3 {
    margin-top: var(--sp-ref-spacing-12);
    margin-bottom: var(--sp-ref-spacing-2);
    font-size: 1rem;
  }

  :deep(sp-info-message) p {
    margin: 0;
  }

  :deep(sp-info-message) p + p {
    margin-top: var(--sp-ref-spacing-4);
  }

  :deep(.bulk-import-table-container) {
    max-width: none;
    overflow-x: auto;
    overflow-y: hidden;
  }

  :deep(.bulk-import-table) {
    margin: var(--sp-ref-spacing-5) 0;
    border: var(--sp-ref-spacing-px) solid rgba(49, 112, 143, 0.5);
    border-collapse: collapse;
  }

  :deep(.bulk-import-table) th {
    white-space: nowrap;
  }

  :deep(.bulk-import-table) td,
  :deep(.bulk-import-table) th {
    text-align: center;
    padding: var(--sp-ref-spacing-2);
    border: var(--sp-ref-spacing-px) solid rgba(49, 112, 143, 0.5);
  }

  :deep(.column-description-container) {
    max-height: var(--sp-ref-spacing-48);
    overflow-y: auto;
  }

  :deep(.sample-link) {
    display: none;
  }

  :deep(sp-info-message) a {
    color: var(--sp-sys-color-primary, #1976d2);
  }

  :deep(sp-info-message) a:hover {
    text-decoration: underline;
  }
}
</style>
